import {IApplication} from './IApplication';

export class DevIntegrationApp implements IApplication {
    constructor(private app: IApplication, private windowObj: Window) {
    }

    public run(): void {
        this.app.run();
        this.windowObj.patchAirBridge = () => {
            if (!this.windowObj.AirBridge) {
                this.windowObj.AirBridge = {
                    evoke: (s) => {
                        this.windowObj.location.href = `about:e4k:${s}`;
                    }
                }
                this.windowObj.hide = () => {
                    this.windowObj.AirBridge.evoke('hide');
                }
                const emulatorCloseBtn = document.getElementById('emulator-close');
                emulatorCloseBtn.style.display = 'block';
                emulatorCloseBtn.onclick = this.windowObj.hide;
            }
        }
    }
}
